import React from 'react';
import PropTypes from 'prop-types';
import TabBar from '@alltrails/shared/denali/components/TabBar';
import * as styles from './styles/styles.module.scss';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

const ProfileSlidingTabs = ({ tabs, context }) => {
  const tabLinks = tabs.map(({ label, linkPath, openInNewWindow }) => {
    const href = LanguageSupportUtil.wrapUrlSafe(linkPath, context?.languageRegionCode);
    const target = openInNewWindow ? '_blank' : null;
    return {
      id: label,
      label,
      testId: `profile-tab-${label}`,
      linkInfo: { href, target }
    };
  });

  return (
    <div className={styles.profileSlidingTabsContainer}>
      <TabBar
        activeTab={tabs.find(tab => tab.isActive).label}
        className={styles.tabBar}
        hideBottomBorder
        onChange={() => {
          // Tabs are all links, no onChange needed
        }}
        tabs={tabLinks}
        testId="profile-tab-bar"
      />
    </div>
  );
};

ProfileSlidingTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string,
      isActive: PropTypes.bool,
      openInNewWindow: PropTypes.bool
    })
  )
};

ProfileSlidingTabs.defaultProps = {
  tabs: []
};

export default ProfileSlidingTabs;
